import { Factory, trait } from 'miragejs';
import _setWith from 'lodash/setWith';
import { MSTEAMS_V2_PLUGIN_KEY, SLACK_V2_PLUGIN_KEY } from 'garaje/utils/enums';

export default Factory.extend({
  // there is a hard expectation that all plugins must have a setup_flow key in the
  // manifest so we're inject one here if not defined
  afterCreate(plugin) {
    if (!plugin?.manifest?.setup_flow) {
      _setWith(plugin, ['manifest', 'setup_flow'], [], Object);
    }
  },

  asSlack: trait({
    category: 'host-notifications',
    key: SLACK_V2_PLUGIN_KEY,
    name: 'Slack',
  }),

  asTeams: trait({
    category: 'host-notifications',
    key: MSTEAMS_V2_PLUGIN_KEY,
    name: 'Teams',
  }),
});
